import { render } from "./index.vue?vue&type=template&id=3a38d7dc&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3a38d7dc&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a38d7dc"]])

export default __exports__